/**
 * Created by DejanK on 12/28/2016.
 */
import angular from 'angular'
import './rb-tooltip.scss'
import RbTooltipService from './rb-tooltip.service'
import rbTooltip from './rb-tooltip.cmp'
import rbAbsTooltip from './rb-abs-tooltip.cmp'

export default angular.module('rb.tooltip', [])
  .service('RbTooltipService', RbTooltipService)
  .component('rbTooltip', rbTooltip)
  .directive('rbAbsTooltip', rbAbsTooltip )
